/**
 * Shared types cho các tab form LocalP.
 * Tách FormValues riêng để mỗi tab nhận `Control<LocalPFormValues>`.
 */
import type { LocalPContractType, MeOrIb } from '@/types/api'

export interface LocalPFormValues {
  // General
  contract_no: string
  contract_date: string
  cp_code: string
  seller_ref: string
  quality_code: string
  quality_des_contract: string
  certification: string
  me_or_ib: MeOrIb | ''
  license_cert_no: string
  quantity_kg: number | ''
  no_of_bag: number | ''
  package: string

  // Pricing
  contract_type: LocalPContractType
  outright_price: number | ''
  ptbf_diffs: number | ''
  price_unit: string
  vat_rate: number | ''
  fx: number | ''
  fixed_fx: number | ''
  futures_month: string
  fixation_call: string

  // Logistics
  latest_delivery: string
  delivery_term: string
  delivery_place_code: string
  logistic_cost: number | ''
  trader_in_charge: string

  // Forward / Deposit
  provi_market_rate: number | ''
  stoploss_rate: number | ''
  margin_value_per: number | ''
  margin_limit_per: number | ''
  time_limit: number | ''
  margin_bonus_per: number | ''
  margin_interest_month: number | ''
  deposit_repayment_date: string

  // Intermediary
  is_intermediary: boolean
  shipper_code: string
  contract_shipper_intermediary: string
  outright_shipper_intermediary: number | ''
  ptbfdiffs_shipper_intermediary: number | ''

  // Flags & Notes
  is_issued: boolean
  is_sent_mail: boolean
  is_received_mail: boolean
  is_sent_paper: boolean
  is_received_paper: boolean
  note: string
}

export const EMPTY_LOCALP: LocalPFormValues = {
  contract_no: '',
  contract_date: '',
  cp_code: '',
  seller_ref: '',
  quality_code: '',
  quality_des_contract: '',
  certification: '',
  me_or_ib: '',
  license_cert_no: '',
  quantity_kg: '',
  no_of_bag: '',
  package: '',

  contract_type: 'Outright',
  outright_price: '',
  ptbf_diffs: '',
  price_unit: '',
  vat_rate: '',
  fx: '',
  fixed_fx: '',
  futures_month: '',
  fixation_call: '',

  latest_delivery: '',
  delivery_term: '',
  delivery_place_code: '',
  logistic_cost: '',
  trader_in_charge: '',

  provi_market_rate: '',
  stoploss_rate: 0.75,
  margin_value_per: 0.7,
  margin_limit_per: '',
  time_limit: '',
  margin_bonus_per: '',
  margin_interest_month: '',
  deposit_repayment_date: '',

  is_intermediary: false,
  shipper_code: '',
  contract_shipper_intermediary: '',
  outright_shipper_intermediary: '',
  ptbfdiffs_shipper_intermediary: '',

  is_issued: false,
  is_sent_mail: false,
  is_received_mail: false,
  is_sent_paper: false,
  is_received_paper: false,
  note: '',
}
